// Warm paper tile with the roaster initial — no real product photos yet,
// matching the design's placeholder convention.
export function BagTile({ label, size }: { label: string; size: number }) {
  const initial = label.trim()[0]?.toUpperCase() ?? '?';
  return (
    <div
      className="flex shrink-0 items-center justify-center rounded-lg bg-wolisho-brown/[0.06] font-bold text-wolisho-brown/40"
      style={{ width: size, height: size, fontSize: size * 0.34 }}
      aria-hidden="true"
    >
      {initial}
    </div>
  );
}
